const SHOPIFY_ROOT_URL = process.env.REACT_APP_SHOPIFY_URL || 'https://somn-demo.myshopify.com';
// eslint-disable-next-line import/prefer-default-export
export const getShopifyUrl = (path = '') => `${SHOPIFY_ROOT_URL}${path}`;
